import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import * as Sentry from '@sentry/nextjs';
import type { NextPage } from 'next';
import type { ErrorProps } from 'next/error';
import styles from './ErrorPage.module.scss';
import { useSearchParams } from 'next/navigation';

const cx = classNames.bind(styles);

export const RETRY_URL_FIELD_NAME = 'retryUrl';

const ErrorPage: NextPage<ErrorProps> = () => {
  const searchParams = useSearchParams();
  const retryUrl = searchParams.get(RETRY_URL_FIELD_NAME);

  useEffect(() => {
    Sentry.captureException(`Login Page Error, retryUrl: ${retryUrl}`);
  }, [retryUrl]);

  return (
    <div className={cx('ErrorPage')}>
      <div className={cx('panel')}>
        <em>일시적인 오류가 발생했습니다.</em>
        {retryUrl ? (
          <>
            <p className={cx('description')}>아래 버튼을 눌러서 재접속 해주세요.</p>

            <div className={cx('buttons')}>
              <a href={retryUrl} className={cx('default')}>
                다시 접속하기
              </a>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
